module.exports = __webpack_public_path__ + "img/rank19.177784e5.png";